// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_ta-0";